import { AsyncLoadingState } from "@/features/dashboard/enums/common";
import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { fetchCurriculum } from "../slices";
import { Entity } from "@/enums";
import { getRosterInfo } from "@/hooks/useRosterInfo";
import { createLessons } from "../slices";


export const handleCreateLessons = (listenerApi: any) => {
  try {
    const { weeklyPlan, reports, userData } = listenerApi.getState() as RootState;
    if (
      weeklyPlan.fetchCurriculumLoading === AsyncLoadingState.SUCCESS &&
      weeklyPlan.data?.assignments &&
      weeklyPlan.data?.dateFrom &&
      weeklyPlan.data?.dateTo &&
      weeklyPlan.data?.curriculumInfo
    ) {
      const {students} = getRosterInfo(reports, userData);

      const props = {
        assignments: weeklyPlan.data.assignments,
        dateFrom: weeklyPlan.data.dateFrom,
        dateTo: weeklyPlan.data.dateTo,
        curriculumInfo: weeklyPlan.data.curriculumInfo,
        stories: weeklyPlan.data.stories,
        studentCount: students.length,
      };
      listenerApi.dispatch(createLessons(props));
    }
  } catch (error) {
    console.error(
      "Error creating lessons from fetched assignments & curriculum:",
      error
    );
    // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
  }
}

export const addCurriculumFetchListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: fetchCurriculum.fulfilled,
    effect: async (action: any, listenerApi: any) => {
      try {
        const { weeklyPlan } = listenerApi.getState() as RootState;
        if (
          weeklyPlan.fetchCurriculumLoading === AsyncLoadingState.SUCCESS &&
          weeklyPlan.data?.assignments &&
          weeklyPlan.data?.curriculumInfo
        ) {
          const {assignments, curriculumInfo} = weeklyPlan.data;
          const skillIds = assignments.reduce((acc, cur) => {
            if (cur.entityType === Entity.DISTRICT) {
              const lessonPlan = curriculumInfo.find(ci => ci.lessonId === cur.lessonPlanId);
              lessonPlan?.skills.forEach(s => {
                if (s.skillId && acc.findIndex(a => a === s.skillId) === -1) {
                  acc.push(s.skillId);
                }
              })
            }
            return acc;
          }, [] as string[]);

          handleCreateLessons(listenerApi);
        }
      } catch (error) {
        console.error(
          "Error fetching default story data for district assignments",
          error
        );
        // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
      }
    },
  });
};
